import React, { Component } from "react";
import { GenIcon } from "react-icons/lib";
import { UncontrolledTooltip, Badge } from "reactstrap";

import { FiCamera, FiPrinter, FiClock, FiBell, FiSend, FiShare2, FiColumns, FiSave, FiMail, FiDownload } from "react-icons/fi";
import { TiArrowMaximise, TiArrowMinimise } from "react-icons/ti";
import { FaChevronLeft, FaChevronRight, FaFileExcel, FaWhatsapp, FaCheck, FaTimes, FaCreativeCommonsZero, FaCodeBranch, FaHeading, FaChartArea, FaFilter, FaBuilding, FaRegStar, FaSlideshare, FaMobile, FaWhatsappSquare, FaHistory, FaUserTie, FaFileInvoiceDollar, FaChevronDown, FaUpload } from "react-icons/fa";
import { AiOutlineExclamationCircle, AiOutlineFullscreen, AiOutlineClear, AiOutlineQuestionCircle, AiOutlineLineChart, AiOutlineAreaChart, AiOutlineSearch, AiFillLayout, AiOutlinePause, AiOutlineStock, AiOutlineRadarChart, AiOutlineBarChart, AiFillPieChart, AiTwotoneBank, AiFillSetting } from "react-icons/ai";
import { FcPrint, FcDownload, FcSettings, FcExpand, FcPlus, FcAreaChart, FcPieChart, FcCurrencyExchange, FcSearch, FcBarChart, FcScatterPlot, FcDoughnutChart, FcCandleSticks, FcPrevious, FcNext } from "react-icons/fc";

import Security from "./security.svg";
import SignOut from "./exit.svg";
import GanttIcon from "./gantt.svg"
import LanguageImg from "./changelang.png"
import Award1 from "./award1.png";
import Award2 from "./award2.png";
import Award3 from "./award3.png";
import Award4 from "./award4.png";
import Award5 from "./award5.png";
import Award6 from "./award6.png";



import { MdPlaylistAdd, MdAddCircleOutline, MdDateRange, MdDevicesOther, MdCompare, MdMergeType, MdMoreVert, MdDashboard, MdLibraryAdd, MdBubbleChart, MdNavigateNext, MdLanguage, MdNavigateBefore, MdDelete, MdEmail, MdArrowDropDown, MdHistory, MdTextsms, } from "react-icons/md";
import { IoMdGitCompare, IoMdGitNetwork, IoLogoWhatsapp, IoMdArrowDropdown, IoIosFingerPrint, IoMdAdd } from "react-icons/io";
import { RiArrowLeftCircleLine, RiUserVoiceLine, RiCurrencyLine, RiBuilding3Line, RiBankLine, RiSearch2Line, RiArrowRightCircleLine, RiArrowDownCircleLine, RiSlideshow3Line, RiArrowGoBackLine, RiCheckLine } from "react-icons/ri";
import { BsBoxArrowUpRight, BsBoxArrowInUp, BsBoxArrowDown, BsBuilding, BsTable, BsArrowLeft, BsChevronDown } from "react-icons/bs";
import { GrSystem, GrSearchAdvanced, GrLanguage, GrFormPrevious, GrFormNext } from "react-icons/gr";
import { GiPoliceBadge, GiBrain } from "react-icons/gi";
import { GoPencil } from "react-icons/go";
import rs2000 from "../../images/currencies/2000rs.jpg";


var FcPrintGray = function (props) {
  return GenIcon({ "tag": "svg", "attr": { "version": "1", "viewBox": "0 0 48 48", "enableBackground": "new 0 0 48 48" }, "child": [{ "tag": "rect", "attr": { "x": "9", "y": "11", "fill": "#424242", "width": "30", "height": "3" } }, { "tag": "path", "attr": { "fill": "#616161", "d": "M4,25h40v-7c0-2.2-1.8-4-4-4H8c-2.2,0-4,1.8-4,4V25z" } }, { "tag": "path", "attr": { "fill": "#424242", "d": "M8,36h32c2.2,0,4-1.8,4-4v-8H4v8C4,34.2,5.8,36,8,36z" } }, { "tag": "circle", "attr": { "fill": "#dddddd", "cx": "40", "cy": "18", "r": "1" } }, { "tag": "rect", "attr": { "x": "11", "y": "4", "fill": "#dddddd", "width": "26", "height": "10" } }, { "tag": "path", "attr": { "fill": "#242424", "d": "M37.5,31h-27C9.7,31,9,30.3,9,29.5v0c0-0.8,0.7-1.5,1.5-1.5h27c0.8,0,1.5,0.7,1.5,1.5v0 C39,30.3,38.3,31,37.5,31z" } }, { "tag": "rect", "attr": { "x": "11", "y": "31", "fill": "#dddddd", "width": "26", "height": "11" } }, { "tag": "rect", "attr": { "x": "11", "y": "29", "fill": "#dddddd", "width": "26", "height": "2" } }, { "tag": "g", "attr": { "fill": "#dddddd" }, "child": [{ "tag": "rect", "attr": { "x": "16", "y": "33", "width": "17", "height": "2" } }, { "tag": "rect", "attr": { "x": "16", "y": "37", "width": "13", "height": "2" } }] }] })(props);
};
FcPrintGray.displayName = "FcPrintGray";


export const RelevantIcon = ({ icon, current, style = {}, onClick, tooltip, className = "" }) => {
  if (icon == 'aadhaarScanner') {
    return <FiCamera onClick={() => {
      let { opensimplemodals } = current.props.parentState;
      opensimplemodals.push(icon);
      current.props.liftGlobalState({ name: 'opensimplemodals' }, opensimplemodals);
    }} style={style} className={className} />;
  }
  else if (icon == 'selfWhatsApp') {
    return (
      // <div className="col-sm-12" onClick={onClick} style={{}}>
      <FaWhatsapp onClick={onClick} style={{ color: "green", position: "absolute", marginLeft: 5, marginRight: 5, marginTop: -3, height: 25, ...style, }} className="hand" className={className} />
      // </div>
    )
  }
  else if (icon == 'whatsapp') {
    return (
      <FaWhatsappSquare onClick={onClick} style={{ color: "#4DD466", ...style }} className={className} />
    )
  }
  else if (icon == 'email') {
    return (
      <FiMail onClick={onClick} style={{ color: "#D44638", ...style }} className={className} />
    )
  }
  else if (icon == 'app') {
    return (
      <FaMobile onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'tick') {
    return (
      // <div className="col-sm-12" onClick={onClick} style={{}}>
      <FaCheck onClick={onClick} style={style} className={className} />
      // </div>
    )
  }
  else if (icon == 'cross') {
    return (
      // <div className="col-sm-12" onClick={onClick} style={{}}>
      <FaTimes onClick={onClick} style={style} className={className} />
      // </div>
    )
  }
  else if (icon == 'plus-color') {
    return (
      // <div className="col-sm-12" onClick={onClick} style={{}}>
      <FcPlus onClick={onClick} style={style} className={className} />
      // </div>
    )
  }
  else if (icon == 'table') {
    return (
      // <div className="col-sm-12" onClick={onClick} style={{}}>
      <BsTable onClick={onClick} style={style} className={className} />
      // </div>
    )
  }
  else if (icon == 'search-color') {
    return (
      // <div className="col-sm-12" onClick={onClick} style={{}}>
      <FcSearch onClick={onClick} style={style} className={className} />
      // </div>
    )
  }
  else if (icon == 'mis') {
    return (
      <FaUserTie onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'sms') {
    return (
      <MdTextsms onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == '2000rs') {
    return (
      // <FcPrivacy  onClick={onClick} style={style}  className={className} />
      <img onClick={onClick} style={{ height: 25, ...style }} src={rs2000} className={className} />
    )
  }

  else if (icon == 'lock-color') {
    return (
      // <FcPrivacy  onClick={onClick} style={style}  className={className} />
      <img onClick={onClick} style={{ height: 25, ...style }} src={Security} className={className} />
    )
  }
  else if (icon == 'lang-color') {
    return (
      // <FcPrivacy  onClick={onClick} style={style}  className={className} />
      <img onClick={onClick} style={{ height: 25, ...style }} src={LanguageImg} className={className} />
    )
  }
  else if (icon == 'award1') {
    return (
      <div
        id="award1"
      >
        <img onClick={onClick} style={{ ...style }} src={Award1} className={className} />
        <UncontrolledTooltip placement="bottom" target="award1">
          <span>{tooltip}</span>
        </UncontrolledTooltip>
      </div>
    )
  }
  else if (icon == 'award2') {
    return (
      <div
        id="award2"
      >
        <img onClick={onClick} style={{ ...style }} src={Award2} className={className} />
        <UncontrolledTooltip placement="bottom" target="award2">
          <span>{tooltip}</span>
        </UncontrolledTooltip>
      </div>)
  } else if (icon == 'award3') {
    return (
      <div
        id="award3"
      >
        <img onClick={onClick} style={{ ...style }} src={Award3} className={className} />
        <UncontrolledTooltip placement="bottom" target="award3">
          <span>{tooltip}</span>
        </UncontrolledTooltip>
      </div>
    )
  } else if (icon == 'award4') {
    return (
      <div
        id="award4"
      >
        <img onClick={onClick} style={{ ...style }} src={Award4} className={className} />
        <UncontrolledTooltip placement="bottom" target="award4">
          <span>{tooltip}</span>
        </UncontrolledTooltip>
      </div>
    )
  } else if (icon == 'award5') {
    return (
      <div
        id="award5"
      >
        <img onClick={onClick} style={{ ...style }} src={Award5} className={className} />
        <UncontrolledTooltip placement="bottom" target="award5">
          <span>{tooltip}</span>
        </UncontrolledTooltip>
      </div>
    )
  }
  else if (icon == 'award6') {
    return (
      <div
        id="award6"
      >
        <img onClick={onClick} style={{ ...style }} src={Award6} className={className} />
        <UncontrolledTooltip placement="bottom" target="award6">
          <span>{tooltip}</span>
        </UncontrolledTooltip>
      </div>
    )
  }



  else if (icon == 'right-arrow-circle') {
    return (
      <RiArrowRightCircleLine onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'left-arrow-circle') {
    return (
      <RiArrowLeftCircleLine onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'down-arrow-circle') {
    return (
      <RiArrowDownCircleLine onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'back-arrow') {
    return (
      <BsArrowLeft onClick={onClick} style={{ height: 25, ...style }} className={className} />
    )
  }

  else if (icon == 'down-carat-solid') {
    return (
      <MdArrowDropDown onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'down-carat') {
    return (
      <FaChevronDown onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'right-carat') {
    return (
      <FaChevronRight onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'left-carat') {
    return (
      <FaChevronLeft onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'language') {
    return (
      <MdLanguage onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'printer-color') {
    return (
      <FcPrint onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'printer-color-disabled') {
    return (
      <FcPrintGray onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'printer') {
    return (
      <FiPrinter onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'bell') {
    return (
      <FiBell onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'send') {
    return (
      <FiSend onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'clock') {
    return (
      <FiClock onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'separate') {
    return (
      <TiArrowMaximise onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'group') {
    return (
      <TiArrowMinimise onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'exclaim-circle') {
    return (
      <AiOutlineExclamationCircle onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'chart') {
    return (
      <AiOutlineLineChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'report-full') {
    return (
      <AiOutlineFullscreen onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'share') {
    return (
      <FiShare2 onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'comment') {
    return (
      <GoPencil onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'present') {
    return (
      <FaSlideshare onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'next-page-color') {
    return (
      <FcNext onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'prev-page-color') {
    return (
      <FcPrevious onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'prev-page') {
    return (
      <MdNavigateBefore onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'next-page') {
    return (
      <MdNavigateNext onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'compare') {
    return (
      <IoMdGitCompare onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'compare2') {
    return (
      <MdCompare onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'fingerprint') {
    return (
      <IoIosFingerPrint onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'face-reco') {
    return (
      <RiUserVoiceLine onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'star') {
    return (
      <FaRegStar onClick={onClick} style={style} className={className} />
    )
  }

  else if (icon == 'other') {
    return (
      <MdDevicesOther onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'dates') {
    return (
      <MdDateRange onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'zerobal') {
    return (
      <FaCreativeCommonsZero onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'separator') {
    return (
      <div>|</div>
    )
  }
  else if (icon == 'mergetype') {
    return (
      <MdMergeType onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'currencyconv') {
    return (
      <RiCurrencyLine onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'download-color') {
    return (
      <FcDownload onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'download') {
    return (
      <FiDownload onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'signout-color') {
    return (
      <img onClick={onClick} style={{ height: 25, ...style }} src={SignOut} className={className} />
    )
  }
  else if (icon == 'question-circle') {
    return (
      <AiOutlineQuestionCircle onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'settings-color') {
    return (
      <FcSettings onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'settings') {
    return (
      <AiFillSetting onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'present-slide') {
    return (
      <RiSlideshow3Line onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'revert') {
    return (
      <RiArrowGoBackLine onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'accept') {
    return (
      <RiCheckLine onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'showmore-color') {
    return (
      <FcExpand onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'more-options') {
    return (
      <MdMoreVert onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'search') {
    return (
      <AiOutlineSearch onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'search2') {
    return (
      <RiSearch2Line onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'save') {
    return (
      <FiSave onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'delete') {
    return (
      <MdDelete onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'import') {
    return (
      <BsBoxArrowInUp onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'excel') {
    return (
      <FaFileExcel onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'new-tab') {
    return (
      <BsBoxArrowUpRight onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'file-upload') {
    return (
      <FaUpload onClick={onClick} style={style} className={className} />
    )
  }

  else if (icon == 'history') {
    return (
      <MdHistory onClick={onClick} style={style} className={className} />
    )
  }

  else if (icon == 'export') {
    return (
      <BsBoxArrowDown onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'piechart-color') {
    return (
      <FcPieChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'piechart-disabled') {
    return (
      <FcPieChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'pie-chart2') {
    return (
      <AiFillPieChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'layout') {
    return (
      <AiFillLayout onClick={onClick} style={style} className={className} />
    )
  }

  else if (icon == 'dashboard') {
    return (
      <MdDashboard onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'branch') {
    return (
      <IoMdGitNetwork onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'ho') {
    return (
      <FaBuilding onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'nabard') {
    return (
      <BsBuilding onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'mscbank') {
    return (
      <RiBuilding3Line onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'rbi') {
    return (
      <AiTwotoneBank onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'branchbi') {
    return (
      <GiBrain onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'it') {
    return (
      <FaFileInvoiceDollar onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'fiu') {
    return (
      <GiPoliceBadge onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'add-list') {
    return (
      <MdPlaylistAdd onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'clear-form') {
    return (
      <AiOutlineClear onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'addon') {
    return (
      <MdLibraryAdd onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'addnew') {
    return (
      <MdLibraryAdd onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'add') {
    return (
      <MdAddCircleOutline onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'bar-chart') {
    return (
      <AiOutlineBarChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'line-chart') {
    return (
      <AiOutlinePause onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'bar-chart-color') {
    return (
      <FcBarChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'area-chart') {
    return (
      <FaChartArea onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'scatter-plot') {
    return (
      <FcScatterPlot onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'stock-chart') {
    return (
      <AiOutlineStock onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'surface-chart') {
    return (
      <AiOutlineAreaChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'surface-chart-color') {
    return (
      <FcAreaChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'doughnut-chart') {
    return (
      <FcDoughnutChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'bubble-chart') {
    return (
      <MdBubbleChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'radar-chart') {
    return (
      <AiOutlineRadarChart onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'candle-plot') {
    return (
      <FcCandleSticks onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'gantt-chart') {
    return (
      <img onClick={onClick} style={{ height: 25, ...style }} src={GanttIcon} className={className} />
    )
  }
  else if (icon == 'basic-filter') {
    return (
      <FaFilter onClick={onClick} style={style} className={className} />
    )
  }
  else if (icon == 'advanced-filter') {
    return (
      <GrSearchAdvanced onClick={onClick} style={style} className={className} />
    )
  }
  else {
    return (
      <MdLibraryAdd onClick={onClick} style={style} className={className} />
    )
  }
}